import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";

class Frequency {
    public Code: string;
    public DescriptionFr: string;
    public DescriptionEn: string;
    public DescriptionESMX: string;
    public IntervalInDaysNumerator?: number;
    public IntervalInDaysDenominator?: number;

    public Position: number;

    public static GetLocalizedDescription(r: Frequency): string {
        if (sessionStore.userLanguageCode == "fr")
            return r.DescriptionFr;
        else if (sessionStore.userLanguageCode == "en")
            return r.DescriptionEn;
        else if (sessionStore.userLanguageCode == "es-MX")
            return r.DescriptionESMX;
    }
    public static ToComboboxItem(r: Frequency): ComboBoxDropDownItem {
        return new ComboBoxDropDownItem(
            r.Code,
            Frequency.GetFrequencyFullDescription(r),
            r.Position,
            cacheStore.GetString("FrequencyLabel")
        );
    }

    private static GetFrequencyFullDescription(r: Frequency): string {
        if (r.Code === "QD" && sessionStore.getCurrentEmployee().isActiveSiteQuebec())
            return "DIE - " + Frequency.GetLocalizedDescription(r);

        return r.Code + " - " + Frequency.GetLocalizedDescription(r);
    }
}

export { Frequency };
